var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelBarbijoTela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.36 19.18C11.6468 19.18 12.69 18.1368 12.69 16.85C12.69 15.5632 11.6468 14.52 10.36 14.52C9.07318 14.52 8.03 15.5632 8.03 16.85C8.03 18.1368 9.07318 19.18 10.36 19.18Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.64 19.18C22.9268 19.18 23.97 18.1368 23.97 16.85C23.97 15.5632 22.9268 14.52 21.64 14.52C20.3532 14.52 19.31 15.5632 19.31 16.85C19.31 18.1368 20.3532 19.18 21.64 19.18Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 13.45C22.3 9.9706 19.4794 7.14999 16 7.14999C12.5206 7.14999 9.7 9.9706 9.7 13.45V19.15C9.7 22.6294 12.5206 25.45 16 25.45C19.4794 25.45 22.3 22.6294 22.3 19.15V13.45Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 16C13.55 16 12.11 19.1 9.47 19.1V21.2C9.94076 22.5272 10.8125 23.6751 11.9645 24.4849C13.1165 25.2947 14.4918 25.7264 15.9 25.72C17.3295 25.7122 18.7242 25.2779 19.9053 24.4726C21.0865 23.6673 22.0004 22.5278 22.53 21.2V19.14C19.6 19.14 18.25 16 15.9 16Z",
    fill: "#FFCA15",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.04V25.72",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.70001C10.48 5.70001 6.9 10.38 9.69 16.53C9.69 16.53 9.59 10.09 12.11 10.09C12.11 10.09 12.71 10.79 16 10.79C19.29 10.79 19.89 10.09 19.89 10.09C22.41 10.09 22.31 16.53 22.31 16.53C25.1 10.38 21.52 5.70001 16 5.70001Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.11 10.09C14.56 11.41 17.67 12.38 16.51 11.19C16.4952 11.1705 16.4868 11.147 16.4857 11.1226C16.4847 11.0982 16.4911 11.0741 16.5042 11.0534C16.5172 11.0328 16.5362 11.0166 16.5587 11.007C16.5812 10.9975 16.6061 10.995 16.63 11C18.72 11.69 25.01 13.62 19.89 10.09",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.11 10.09C14.56 11.41 17.67 12.38 16.51 11.19C16.4952 11.1705 16.4868 11.147 16.4857 11.1226C16.4847 11.0982 16.4911 11.0741 16.5042 11.0534C16.5172 11.0328 16.5362 11.0166 16.5587 11.007C16.5812 10.9975 16.6061 10.995 16.63 11C18.72 11.69 25.01 13.62 19.89 10.09",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelBarbijoTela);
export default __webpack_public_path__ + "static/media/SelBarbijoTela.a99051174d5c93b67567eb234ac107ef.svg";
export { ForwardRef as ReactComponent };